<template>
    <div class="legal-notice">
      <h1>Aviso legal</h1>
      <section>
        <h2>Nombre comercial</h2>
        <p>
          Geobizi.
        </p>
      </section>
      <section>
        <h2>Localización de la sede central</h2>
        <p>
          Calle Enkarterri N3 bis<br>
          48840, Güeñes, Bizkaia
        </p>
      </section>
      <section>
        <h2>Correo electrónico</h2>
        <p>geobizi@hotmail.com</p>
      </section>
      <section>
        <h2>Otros datos</h2>
        <p>
          La CEO Aintzane Goffard Sevillano, es programadora web Full Stack y geóloga licenciada con Máster en cuaternario: Cambios Ambientales y Huella Humana en la universidad del País Vasco. Inscrita en el Ilustre colegio oficial de geólogos con el Nº 8111. Desarrolladora, diseñadora, formadora, comunicadora, coordinadora, monitora, técnico especialista, guía, con titulaciones/conocimientos/formación en psicología, pedagogía, arteterapia, mindfulness, medioambiente, arqueología, musicoterapia, docencia, formación, turismo, cosmética natural y fitoterapia entre otros.
        </p>
        <p>
          Prestamos servicios de biorregeneración colaborativa, talleres, formaciones, rutas y actividades relacionadas con la geología, el medioambiente, conexión con la naturaleza, bienestar y ciencia. También diseñamos y vendemos distintos tipos de materiales con varias finalidades como: materiales para talleres, juguetes científicos, formaciones y similares.
        </p>
        <p>
          Los precios que aparecen salvo que esté expresamente descrito, llevan el IVA incluido (21%) salvo en los casos de formación exenta de IVA. Los gastos de envío se indican en la página de comercio electrónico y variarán en función del tipo de envío, el lugar, y la elección del comprador.
        </p>
        <p>Para más información, contactar vía teléfono o mail.</p>
      </section>
      <section>
        <h2>Última modificación</h2>
        <p>20/02/2025</p>
      </section>
      <section>
        <h2>Contacto</h2>
        <p>
          Teléfono: 677170921<br>
          E-mail: geobizi@hotmail.com
        </p>
      </section>
    </div>
  </template>
  
  <script setup>
  </script>
  
  <style scoped>
  .legal-notice {
    padding-top: 7rem;
    max-width: 800px;
    margin: 0 auto;
    padding-left: 2rem;
    padding-right: 2rem;
    padding-bottom: 2rem;
    font-family: Arial, sans-serif;
    color: var(--darkgrey);
    line-height: 1.6;
  }
  
  h1, h2 {
    color: var(--darkgreen);
  }
  </style>
  